import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `FichaVerraco/generarExcel`, method: 'POST', body: values, token: token})
}
